import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../seo/seo.service';
import { PreventivoComponent } from '../../components/preventivo-module/preventivo-module';

@Component({
  standalone: true,
  selector: 'app-preventivo-page',
  imports: [PreventivoComponent],
  templateUrl: './preventivo.html',
  styleUrls: ['./preventivo.scss']
})
export class PreventivoPageComponent implements OnInit {

  constructor(private seo: SeoService) {}

  ngOnInit(): void {

    this.seo.updateTags({
      title: 'Preventivo pulizie Pescara e Giulianova | SAMI Pulizie',
      description:
        'Richiedi un preventivo gratuito per pulizie a Pescara, Giulianova, Teramo e provincia. Contatta direttamente la sede più vicina.',
      keywords:
        'preventivo pulizie Pescara, preventivo pulizie Giulianova, impresa pulizie Teramo, richiesta preventivo pulizie',
      canonicalUrl: '/preventivo',

      ogTitle: 'Richiedi il tuo Preventivo - Samy Pulizie',
      ogDescription:
        'Compila il modulo online e ricevi un preventivo dettagliato e gratuito per pulizie e sanificazioni.',
      ogImage: 'https://www.samipulizie.it/assets/logo-sami-natale.png',
      ogUrl: 'https://samipulizie.it/preventivo',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Richiedi Preventivo - Samy Pulizie',
        description:
          'Modulo ufficiale per richiedere un preventivo gratuito per pulizie domestiche, uffici, condomini e sanificazioni.',
        url: 'https://www.samipulizie.it/preventivo',
        publisher: {
          '@type': 'Organization',
          name: 'Samy Pulizie',
          logo: {
            '@type': 'ImageObject',
            url: 'https://www.samipulizie.it/assets/logo-sami-natale.png'
          }
        }
      }
    });
  }
}
